import React, { useState } from 'react';
import './TrigCalculator.css';
const canvas = document.getElementById('Matrix');
const context = canvas.getContext('2d');

const TrigCalculator = () => {
  const [activeTab, setActiveTab] = useState('tangent');
  const [angle, setAngle] = useState('');
  const [tangentResult, setTangentResult] = useState(null);
  const [rise, setRise] = useState('');
  const [run, setRun] = useState('');
  const [arctangentResult, setArctangentResult] = useState(null);

  const calculateTangent = () => {
    const angleRad = parseFloat(angle) * (Math.PI / 180);
    const result = Math.tan(angleRad);
    setTangentResult({
      ratio: result.toFixed(4),
      rise: Math.sin(angleRad).toFixed(4),
      run: Math.cos(angleRad).toFixed(4)
    });
  };

  const calculateArctangent = () => {
    const riseVal = parseFloat(rise);
    const runVal = parseFloat(run);
    const ratio = riseVal / runVal;
    const angleRad = Math.atan2(riseVal, runVal);
    const angleDeg = angleRad * (180 / Math.PI);
    setArctangentResult({
      angle: angleDeg.toFixed(2),
      ratio: ratio.toFixed(4)
    });
  };

  return (
    <div className="calculator-container">
      <div className="calculator-header">
        <h1>Tangent & Arctangent Calculator</h1>
      </div>
      <div className="calculator-content">
        <div className="tabs">
          <button 
            className={`tab ${activeTab === 'tangent' ? 'active' : ''}`}
            onClick={() => setActiveTab('tangent')}
          >
            Tangent (angle → ratio)
          </button>
          <button 
            className={`tab ${activeTab === 'arctangent' ? 'active' : ''}`}
            onClick={() => setActiveTab('arctangent')}
          >
            Arctangent (ratio → angle)
          </button>
        </div>
        
        {activeTab === 'tangent' && (
          <div className="tab-content">
            <div className="input-group">
              <label>Enter Angle (degrees)</label>
              <input
                type="number"
                value={angle}
                onChange={(e) => setAngle(e.target.value)}
                placeholder="Enter angle in degrees"
              />
            </div>
            
            <button onClick={calculateTangent} className="calculate-btn">
              Calculate Tangent
            </button>

            {tangentResult && (
              <div className="results">
                <p className="result-title">Results:</p>
                <p>Tangent (rise/run) = {tangentResult.ratio}</p>
                <p>Rise = {tangentResult.rise}</p>
                <p>Run = {tangentResult.run}</p>
                <div className="explanation">
                  <p>
                    Tangent of {angle}° means: 
                    For every {tangentResult.run} units you move horizontally,
                    you rise {tangentResult.rise} units vertically
                  </p>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'arctangent' && (
          <div className="tab-content">
            <div className="input-grid">
              <div className="input-group">
                <label>Rise (Opposite)</label>
                <input
                  type="number"
                  value={rise}
                  onChange={(e) => setRise(e.target.value)}
                  placeholder="Enter rise"
                />
              </div>
              <div className="input-group">
                <label>Run (Adjacent)</label>
                <input
                  type="number"
                  value={run}
                  onChange={(e) => setRun(e.target.value)}
                  placeholder="Enter run"
                />
              </div>
            </div>

            <button onClick={calculateArctangent} className="calculate-btn">
              Calculate Arctangent
            </button>

            {arctangentResult && (
              <div className="results">
                <p className="result-title">Results:</p>
                <p>Angle = {arctangentResult.angle}°</p>
                <p>Rise/Run Ratio = {arctangentResult.ratio}</p>
                <div className="explanation">
                  <p>
                    For a rise of {rise} units and a run of {run} units,
                    the angle is {arctangentResult.angle}° from horizontal
                  </p>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="reference">
          <h3>Quick Reference:</h3>
          <ul>
            <li>Tangent (tan) = opposite/adjacent = rise/run</li>
            <li>Arctangent (arctan) = angle from a rise/run ratio</li>
            <li>Arctan2(rise,run) gives the full 360° angle</li>
            <li>Common angles: 45° = 1:1 ratio, 30° = 0.577:1 ratio</li>
          </ul>
        </div>
      </div>
    </div>
  );
};


canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

const katakana = 'アァカサタナハマヤャラワガザダバパイィキシチニヒミリヰギジヂビピウゥクスツヌフムユュルグズブヅプエェケセテネヘメレヱゲゼデベペオォコソトノホモヨョロヲゴゾドボポヴッン';
const latin = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const nums = '0123456789';
const alphabet = katakana + latin + nums;

const fontSize = 16;
const columns = canvas.width/fontSize;

const rainDrops = [];

for( let x = 0; x < columns; x++ ) {
    rainDrops[x] = 1;
}

function draw() {
    context.fillStyle = 'rgba(0, 0, 0, 0.05)';
    context.fillRect(0, 0, canvas.width, canvas.height);
    
    context.fillStyle = 'green';  // Matrix green
    context.font = fontSize + 'px monospace';

    for(let i = 0; i < rainDrops.length; i++) {
        const text = alphabet.charAt(Math.floor(Math.random() * alphabet.length));
        context.fillText(text, i*fontSize, rainDrops[i]*fontSize);
        
        if(rainDrops[i]*fontSize > canvas.height && Math.random() > 0.975){
            rainDrops[i] = 0;
        }
        rainDrops[i]++;
    }
}

setInterval(draw, 30);

// Handle window resize
window.addEventListener('resize', () => {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
});
export default TrigCalculator;